import type { PreClaimsMitigatedTypesResponse } from './api';

export const normalizePreClaimsMitigatedTypes = (
  list: PreClaimsMitigatedTypesResponse,
): {
  label: string;
  value: string;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.value,
    value: row.key,
  }));
};
